import React from 'react';
import PropTypes from 'prop-types';
import Typography from "@material-ui/core/Typography";
import { makeStyles } from '@material-ui/core/styles';


const useStyles = makeStyles(theme => ({
  container: {
    background: '#004a83',
    width: '100%',
  },
  title: {
    color: theme.palette.getContrastText('#004a83'),
    padding: 5,
  },
}))

function Header({ title }) {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <Typography
        className={classes.title}
        padding="none"
      >
        {title}
      </Typography>
    </div>
  )
}

Header.propTypes = {
  title: PropTypes.string,
}

Header.defaultProps = {
  title: ''
}

export default Header;
